import React from 'react'
import { Flex } from '@mobi/component-library/Common/Flex'
import { spacing } from '@mobi/component-library/Theme/Common'
import { Icon } from '@mobi/component-library/Common/Icon'
import type { MysteryDetails, Race } from '@mobi/betslip/types'
import { getIconTypeFromMeetingCode } from '@core/Areas/Quickbet/helpers/IconTypeHelper'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'

interface MysteryInfoProps {
  race: Race
  selectionDetails: MysteryDetails
  isRaceClosed?: boolean
}

export const MysteryInfo = ({ race, selectionDetails, isRaceClosed = false }: MysteryInfoProps) => {
  const { raceNumber, meetingName, raceTime } = race
  const iconType = getIconTypeFromMeetingCode(race.meetingCode)

  return (
    <Flex flexDirection='column' gap={spacing.smx2}>
      <EventInfo
        icon={iconType && <Icon size='2.2rem' type={iconType} />}
        eventInfo={`${meetingName} : R${raceNumber}`}
      />

      <SecondaryInfo
        marketInfo={<span data-tid-quickbet-mystery-type>{selectionDetails.betTypeName}</span>}
        eventStart={raceTime}
        isBettingClosed={isRaceClosed}
      />
    </Flex>
  )
}
